import React from 'react';
import Slider from 'react-slick';

import { SliderContainer, ClientWrapper, ClientImage } from './clients.styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const images = [
  { name: 'logo2', path: require('assets/clients/2.png') },
  { name: 'logo3', path: require('assets/clients/3.png') },
  { name: 'logo4', path: require('assets/clients/4.png') },
  { name: 'logo6', path: require('assets/clients/6.png') },
  { name: 'logo7', path: require('assets/clients/7.png') },
  { name: 'logo9', path: require('assets/clients/9.png') },
  { name: 'logo12', path: require('assets/clients/12.png') },
  { name: 'logo13', path: require('assets/clients/13.png') },
  { name: 'logo14', path: require('assets/clients/14.png') },
  { name: 'logo16', path: require('assets/images/zerply.png') },
  { name: 'logo16', path: require('assets/images/wwa.png') },
  { name: 'logo17', path: require('assets/images/jamstack.png') },
  { name: 'logo20', path: require('assets/images/pp.png') }
];

const Clients = ({ children }) => {
  const settings = {
    dots: false,
    arrows: false,
    centerMode: true,
    touchMove: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: true,
    speed: 2500,
    autoplaySpeed: 2500,
    cssEase: 'linear',

    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };

  return (
    <SliderContainer>
      <Slider {...settings}>
        {images?.map(({ name, path }) => {
          return (
            <ClientWrapper>
              <ClientImage src={path} alt={name} />
            </ClientWrapper>
          );
        })}
      </Slider>
    </SliderContainer>
  );
};

export default Clients;
